var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "text-xs-center", attrs: { flat: "" } },
    [
      _c("v-card-title", { staticClass: "pa-0 justify-center" }, [
        _c("h4", { staticClass: "pb-2" }, [
          _vm._v("\n      " + _vm._s(_vm.campaign.RetireKeepTitle) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _c("v-card-text", { staticClass: "pa-0" }, [
        _c("p", [
          _vm._v("\n      " + _vm._s(_vm.campaign.RetireKeepDesc) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _c("v-card-actions", { staticClass: "justify-center" }, [
        _c(
          "div",
          { staticClass: "button-bar" },
          [
            _c("delete-confirm-modal", {
              attrs: {
                title: _vm.assetName,
                "button-id": "MarkForDeletion",
                "button-class": "sb_btn_solid error",
                "button-text": _vm.campaign.RetireButton,
                "custom-text": 'Retire asset "' + _vm.assetName + '"?',
                "confirm-button-text": "Yes",
                "cancel-button-text": "No",
                "hide-header-title": ""
              },
              on: { confirm: _vm.markForDeletion }
            }),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                staticClass: "ml-3 sb_btn_solid",
                attrs: { id: "KeepButton", color: "success" },
                on: { click: _vm.keepClicked }
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.campaign.KeepButton) + "\n        "
                ),
                _c("v-icon", { staticClass: "ml-1" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.SbIcons.arrow.right) +
                      "\n        "
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }